import { Option } from './option.entity';


export class Subscription {
  id: number;
  offer_id: number;

  max_tracker_nb: number;
  period: number;

  amount: number;
  currency: string;
  status: string;
  payment_mean: string;

  next_charge_at: Date;

  created_at: Date;
  updated_at: Date;
  canceled_at: Date;

  user_id: number;
  trackers: number[];

  payment_id: string;
  payment_additional_id: string;
  bank_account: string;
  customer_id: string;

  options: Option[];
  account_wide_options: Option[];
  option_payments: number[];

  card_pan: string;
  card_expiry: Date;
  card_expiry_string: string;

  option_status: boolean;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/subscription.entity.ts